export const stepOneData = [
  {
    stepOneHeading: "1. Review Your Existing Auto Loan",
    paraOne:
      "Start by gathering the following details from your current loan agreement or lender:",
    categoryHeading: "Credit scores typically fall into these categories.",
    reviewLists: [
      {
        id: 1,
        list: "Current monthly payment.",
      },
      {
        id: 2,
        list: "Interest rate (APR) of the loan.",
      },
      {
        id: 3,
        list: "Number of months remaining.",
      },
      {
        id: 4,
        list: "Payoff amount (this may differ from the loan balance).",
      },
    ],
    paraTwo:
      "Knowing this information will help you determine the savings potential of refinancing.",
  },
];

export const stepTwoData = [
  {
    stepTwoHeading: "2. Determine the Value of Your Car",
    paraOne:
      "The current market value of your car impacts refinancing. Use online tools or dealership estimates to determine your car’s value.",

    tip: "If you owe more than your car’s worth (negative equity), focus on reducing the principal balance by making extra payments before applying for refinancing.",
  },
];

export const stepThreeData = [
  {
    stepThreeHeading: "3. Evaluate Your Credit",
    paraOne:
      "Check your credit score before applying for refinancing. A higher credit score can help secure lower interest rates.",

    tip: " If your credit score has improved in the past 6-12 months due to on-time payments, you’re more likely to benefit from refinancing.",
  },
];

export const stepFourData = [
  {
    stepFourHeading: "4. Gather Information for Your Application",
    paraOne: "Prepare these documents to streamline the application process:",
    infoList: [
      {
        info: "Driver’s license and vehicle registration.",
      },
      {
        info: "Proof of insurance and income.",
      },
      {
        info: "Vehicle Identification Number (VIN).",
      },
      {
        info: "Loan payoff statement from your current lender.",
      },
    ],
  },
];

export const stepFiveData = [
  {
    stepFiveHeading: "5. Compare Lenders and Rates",
    paraOne: "Compare multiple lenders’ offers and consider:",

    lendersList: [
      {
        head: "Loan tenure: ",
        info: "Opt for shorter terms to save on interest.",
      },
      {
        head: "Processing fees: ",
        info: "These can impact overall savings.",
      },
      {
        head: "Prepayment options: ",
        info: "Flexible terms can reduce long-term costs.",
      },
    ],

    paraTwo:
      "Use Minemi’s Car Loan Refinance Calculator to compare offers and make informed decisions.",
  },
];

export const stepSixData = [
  {
    stepSixHeading: "6. Apply to Refinance Your Car Loan",
    paraOne: "Finalize the refinancing process:",

    infoList: [
      {
        info: "Submit the required documents to your chosen lender.",
      },
      {
        info: "Sign the new loan agreement.",
      },
      {
        info: "Ensure your previous loan is paid off.",
      },
    ],

    tip: "Apply to multiple lenders within a 14-day window to minimize the impact on your credit score.",

    paraTwo: "Ways to Save with Car Loan Refinancing",
    refinancingList: [
      {
        head: "Lower Interest Rates: ",
        info: "Negotiate with lenders to reduce APR.",
      },
      {
        head: "Shorter Loan Terms: ",
        info: "Pay off your loan faster to save on interest.",
      },
      {
        head: "EMI Consolidation: ",
        info: "Combine multiple auto-related loans for better manageability.",
      },
      {
        head: "Automatic Payments: ",
        info: "Some lenders offer discounts for auto-debit arrangements.",
      },
    ],
  },
];
